import Feature15_2 from './Feature15_2'
export default Feature15_2
